<template>
    <div class="user-center" :style="{'height': contentH + 'px'}">
        <div class="field-block">
            <div class="field-row">
                <div class="field-title field-title-user">{{userInfo.realname}} / {{userInfo.workerId}} </div>
            </div>
            <div class="field-row field-row-second">
                <div class="field-title" >角色</div>
                <div class="field-values">
                    <div class="field-value" v-for="(role,index) in userInfo.roleNames" :key="index">{{role}}</div>
                </div>
            </div>
            <div class="field-row">
                <div class="field-title" >部门</div>
                <div class="field-values">
                    <div class="field-value" v-for="(dept,index) in userInfo.departIdList" :key="index">{{dept}}</div>
                </div>
            </div>
            <div class="field-row">
                <div class="field-title" >Franchise/DA</div>
                <div class="field-values">
                    <div class="field-value" v-for="(medical_field,index) in userInfo.medicalFieldList" :key="index">{{medical_field}}</div>
                </div>
            </div>
            <div class="field-row">
                <div class="field-title" >团队</div>
                <div class="field-values">
                    <div class="field-value" v-for="(team,index) in userInfo.loginTeams" :key="index">{{team.teamName}}</div>
                </div>
            </div>
            <div class="field-row">
                <div class="field-title" >邮箱</div>
                <div class="field-values">
                    <div class="field-value">{{userInfo.email}}</div>
                </div>
            </div>
        </div>      
    </div>
</template>
<script>
import center from '@/api/user/center';
import { mapGetters } from 'vuex';


export default {
  data() {
    return {
      contentH: 0,
    };
  },
  computed: {
    ...mapGetters(['basedataGetName','userInfo']),
  },
  methods: {
    resizeLayout() {
      this.contentH = document.documentElement.clientHeight;
    }
  },
  beforeDestroy() {
    window.removeEventListener('resize', this.resizeLayout, true)
  },
  mounted() { 
    this.contentH = document.documentElement.clientHeight 
                 - (document.getElementsByClassName('mint-tabbar')[0].clientHeight)
                 - 1;

    window.addEventListener('resize', this.resizeLayout, true);
  }
};
</script>
<style lang="less" scoped>
    .user-center {
        background-color: #ffffff;
        border-bottom: 1px solid #F2F4F8;
    }

    .field-block {
        font-size: 16px;
        color: @subSubFontColor;
        margin: 0 15px;
        padding-top: 10px;
        
        .field-title-user {
            font-weight: bold;
            color: @mainColor !important;
            font-size: 18px;
        }

        .field-title {
            height: 35px;
            line-height: 35px;
            font-weight: bold;
        }

        .field-values {
            margin-top: -10px;
        }

        .field-value {            
            min-height: 34px;
            line-height: 34px;
            border-radius: 17px;
            display: inline-block;
            padding: 0 21px;
            text-align: center;
            background-color: #F6F6F6;
            margin-right: 10px;
            margin-top: 10px;
        }
        
        .field-row {
            background-color: #fff;
            min-height: 35px;
        }

        .field-row + .field-row {
            margin-top: 30px;
        }

        .field-row-second {
            margin-top: 20px !important;
        }
    }
</style>


// WEBPACK FOOTER //
// index.vue?08be9a18